import type { MouseEvent } from 'react';
import type { FriendlyDependencyName } from '../../../constants/dependency';
import { mapFriendlyNameToDisplay } from './utils';

type Props = {
    activeTab: string;
    changeActiveTab: (e: MouseEvent<HTMLButtonElement>, activeTab: FriendlyDependencyName) => void;
    dependencyName: FriendlyDependencyName;
};

const SharedElementTab = ({ activeTab, changeActiveTab, dependencyName }: Props) => {
    return (
        <li className={activeTab === dependencyName ? 'active' : ''}>
            <button
                className="nav-tab"
                onClick={(e) => changeActiveTab(e, dependencyName)}
                title={`${mapFriendlyNameToDisplay(dependencyName)}s`}
                type="button"
            >
                {`${mapFriendlyNameToDisplay(dependencyName)}s`}
            </button>
        </li>
    );
};

export default SharedElementTab;
